import {useSelector} from 'react-redux';

import {useAbortableLoad} from "../../Hooks/index.js";
import DocsRight from "../../old_components/DocsMain/components/DocsRight.jsx";
import "./style.css";

import ContentContainer from "../../Components/ContentContainer/ContentContainer.js";
import {getCriteria} from '../../shared/helpers/getCriteria.js';

export const DocFr = () => {

  const {
    selectedGeoObjArray = [],
    // getMultiGeoObjReport = () => { },
    // geoMultiObjReport = {},
    dateRangeCriteria,
    rangeStartDate,
    rangeEndDate
  } = useSelector((state) => {
    const {
      ui: {
        selectedGeoObjArray,
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate,
      } = {},
      api: {
        geoMultiObjReport,
      } = {},
      service: {
        Api: {
          getMultiGeoObjReport
        } = {}
      } = {}
    } = state;
    return { selectedGeoObjArray, getMultiGeoObjReport, geoMultiObjReport, dateRangeCriteria, rangeStartDate, rangeEndDate }
  })

  const criteria = getCriteria(
    dateRangeCriteria,
    rangeStartDate,
    rangeEndDate,
  )

  const geoMultiObjReport = useAbortableLoad(
    'getMultiGeoObjReport',
    'geoMultiObjReport',
    {
      objIds: selectedGeoObjArray,
      criteria
    },
    selectedGeoObjArray?.length,
    [selectedGeoObjArray, dateRangeCriteria, rangeStartDate, rangeEndDate],
    'setMultiGeoObjReport'
  )

  return (
    <ContentContainer content={(
      <DocsRight data={geoMultiObjReport?.data} loaderInfoSource={geoMultiObjReport}/>

    )} />
  )
}